export default () => {
  document.addEventListener('DOMContentLoaded', function() {
    const headers = document.querySelectorAll('.main__faq__inner__container__block__header');

    headers.forEach((header) => {
      header.addEventListener('click', function() {
        const content = this.nextElementSibling;
        const icon = this.querySelector('.main__faq__inner__container__block__header__icon');

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          icon.textContent = '+';
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          icon.textContent = '-';
        }
      });
    });
  });
}
